/* eslint-disable no-restricted-globals */
import React, { useState } from 'react'
import '../assets/css/login.css'
import SchoolImg from '../assets/image/school.png'
import UserImg from '../assets/image/user.png'
import PassworldImg from '../assets/image/passworld.png'
import config from '../config'
import qs from 'qs';
import axios from 'axios'
import BaoanImg from "../assets/image/1.svg"
import szImg from "../assets/image/2.svg"

// eslint-disable-next-line no-useless-escape
const regEmail = new RegExp("^[A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
// const regpass = new RegExp(/^(?=.*\d)(?=.*[A-Za-z]).{6,}$/);
function Login(props) {
    const [school, setSchool] = useState('')
    const [user, setUser] = useState('')
    const [passworld, setPassworld] = useState('')
    const [timer, setTimer] = useState(0)
    const [schoolNum, setSchoolNum] = useState('')
    const [schoolName, setSchoolName] = useState('')
    const [schoolShow, setSchoolShow] = useState(false)
    const [progressValue, setProgressValue] = useState(0)
    const [loginError, setLoginError] = useState('')
    const [loginState, setLoginState] = useState(false)

    const showAlert = (str) => {
        setLoginError(str)
        setLoginState(true)
    }
    // 登录
    const login = () => {
        console.log('login')
        setLoginState(false)
        let schoolStr = schoolNum ? ('@' + schoolNum) : '@cocorobo.cc'
        let email = ''
        let str = user.replace(/(^\s*)|(\s*$)/g, "")
        if (!regEmail.test(str)) {
            email = str + schoolStr
        } else {
            email = str
        }
        if (passworld.length < 6 || /[\u4e00-\u9fa5]/.test(passworld)) {
            //   this.geetestRegister();
            showAlert(props.lang.passwordError)
            return;
        }
        let progressTimer = setInterval(() => {
            setProgress()
        }, 100);
        let aa = window.location.hostname.indexOf('cocorobo.cn') > -1 || window.location.hostname.indexOf('localhost') > -1
        let params = {
            geetest_challenge: "",
            geetest_validate: "",
            geetest_seccode: "",
            loginUsername: email.trim(),
            // loginPassword: passworld.trim(),
            loginPassword: aa ? window.btoa(passworld.trim()) : passworld.trim(),
        }
        axios.defaults.withCredentials = true;
        // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        axios.post(`${config.api}api/user`, qs.stringify(params)).then(res => {
            clearInterval(progressTimer)
            setProgressValue(100)
            if (res.data.length > 0) {
                setLoginState(false)
                showAlert(props.lang.loginSuccess)
                setTimeout(() => {
                    postMessageToParent('loginVerify', 'logged', res.data[0][0])
                }, 1000)
            } else {
                showAlert(res)
            }
        }).catch(err => {
            showAlert(props.lang.loginError)
            console.log(err)
        })

    }
    const postMessageToParent = (id, status, data) => {
        //TODO: replace origin
        let result = {
            id,
            status,
            data
        }
        window.parent.postMessage(result, '*')
    }
    const schoolChange = (e) => {
        let value = e.target.value
        if (value) {
            clearTimeout(timer)
            setTimer(setTimeout(() => {
                getSchool(value)
            }, 500))
        } else {
            setSchoolShow(false)
        }
        setSchool(e.target.value)
    }

    const getSchool = e => {
        // 获取学校信息
        axios.post(`${config.edu}admin/selectorganize`, qs.stringify({ mode: e })).then(res => {
            console.log(res)
            if (res.data.length > 0) {
                setSchoolNum(res.data[0][0].mail)
                setSchoolName(res.data[0][0].name)
                setSchoolShow(true)
            } else {
                setSchoolName(props.lang.notSchool)
                setSchoolNum("")
                setSchoolShow(true)
            }
        }).catch(err => {
            setSchoolName(props.lang.notSchool)
            setSchoolNum("")
            setSchoolShow(true)
        })
    }
    const userChange = (e) => {
        setUser(e.target.value)
    }
    const passworldChange = (e) => {
        setPassworld(e.target.value)
    }
    const setProgress = () => {
        let num = progressValue + 10
        if (num > 80) {
            num = 85
        }
        setProgressValue(num)
    }
    const enter = (e) => {
        if (e.keyCode === 13) {
            login()
        }
    }
    return (
        <div className="login" onKeyDown={enter}>
            <div className='login-input'>
                <img src={SchoolImg} alt="school" />
                <input onChange={schoolChange} type="text" onBlur={schoolChange} placeholder={props.lang.schoolName} value={school} />
                {schoolShow && <p style={{ marginTop: 5, textAlign: 'left' }}>{schoolName}</p>}
            </div>
            <div className='login-input'>
                <img src={UserImg} alt="user" />
                <input type="text" onChange={userChange} placeholder={props.lang.username} value={user} />
            </div>
            <div className='login-input'>
                <img src={PassworldImg} alt="passworld" />
                <input type="Password" onChange={passworldChange} placeholder={props.lang.password} value={passworld} />
                {loginState && <p style={{ marginTop: 5, textAlign: 'left', color: "red" }}>{loginError}</p>}
            </div>
            <div className='login-input'>
                <button onClick={login}>{props.lang.login}</button>
            </div>
            {/* <div className='login-input '>
                <div className='three-button'> 
                    <span style={{marginRight:30}} onClick={() => {
                        top.location.href = 'https://bjt.baoan.edu.cn/'
                    }}>
                        <img src={szImg} alt="baoan" />宝教通
                        </span>
                    <span onClick={() => {
                            top.location.href = 'https://sz.edu.cn/portal-web/#/'
                        }}>
                        <img src={BaoanImg} alt="shenjiao"/>深教AI
                    </span>
                </div>
            </div> */}
        </div>
    )
}


export default Login;